"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withDefaults = _interopRequireDefault(require("../utils/with-defaults"));

var _dimensions = require("../utils/dimensions");

var _spacer = require("./spacer.styles");

var _jsxRuntime = require("react/jsx-runtime");

const defaultProps = {
  x: 1,
  y: 1
};

const Spacer = ({
  x,
  y,
  inline,
  css,
  ...props
}) => {
  const marginLeft = (0, _dimensions.getMargin)(x);
  const marginTop = (0, _dimensions.getMargin)(y);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_spacer.StyledSpacer, {
    css: {
      marginLeft,
      marginTop,
      ...css
    },
    ...props
  });
};

Spacer.toString = () => '.nextui-spacer';

const MemoSpacer = /*#__PURE__*/_react.default.memo(Spacer);

var _default = (0, _withDefaults.default)(MemoSpacer, defaultProps);

exports.default = _default;
module.exports = exports.default;